import script from "./AppNavbarActions.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppNavbarActions.vue?vue&type=script&lang=ts&setup=true"

import "./AppNavbarActions.vue?vue&type=style&index=0&id=358a58e4&lang=scss"

export default script